export default {
  setGroupList: (state, groupList) => {
    state.groupList = groupList
  }
}
